// @ts-nocheck
import { forwardRef, useCallback, useMemo } from "react";
import moment from "moment";
import { toast } from "react-hot-toast";
import AppFormModal from "../../../../@richbeauty/core/AppFormModal";
import IntlMessages from "../../../../@richbeauty/utility/IntlMessages";
import { useIntl } from "react-intl";
import { revalidateCustomerLeads } from "../../../../@richbeauty/utility/helper/cacheRevalidator";
import useCreateOrEditCustomerLeadFieldConfig from "./useCreateOrEditCustomerLeadFieldConfig";
import useGetCustomerLead from "hooks/apis/customerLeads/useGetCustomerLead";
import useUpdateCustomerLead from "hooks/apis/customerLeads/useUpdateCustomerLead";

const EditCustomerLeadModal = forwardRef(({ id, onSuccess }, ref) => {
  const { messages, formatMessage } = useIntl();
  const { data: dataGetCustomerLead } = useGetCustomerLead(id);
  const createOrEditCustomerLeadFieldConfig =
    useCreateOrEditCustomerLeadFieldConfig({
      isCreate: false,
    });

  const {
    trigger: triggerUpdateCustomerLead,
    isMutating: isMutatingUpdateCustomerLead,
  } = useUpdateCustomerLead();

  const formattedData = useMemo(() => {
    if (!dataGetCustomerLead) return {};
    return {
      ...dataGetCustomerLead,
      zipCode: dataGetCustomerLead.zipCode,
      phoneNumber: dataGetCustomerLead.phoneNumber,
      dob: dataGetCustomerLead.dob ? moment(dataGetCustomerLead.dob) : null,
      gender: dataGetCustomerLead.gender,
      address: dataGetCustomerLead.address,
      city: dataGetCustomerLead.city,
      state: dataGetCustomerLead.state,
      firstName: dataGetCustomerLead.firstName,
      lastName: dataGetCustomerLead.lastName,
      email: dataGetCustomerLead.email,
    };
  }, [dataGetCustomerLead]);

  const onHandleEditCustomerLead = useCallback(
    (formData) => {
      triggerUpdateCustomerLead(
        { formData, id },
        {
          onSuccess: async () => {
            toast.success(
              formatMessage({
                id: "app.customerLeads.editCustomerLead.success",
              })
            );
            revalidateCustomerLeads(id);
            onSuccess?.();
            ref.current?.closeModal();
          },
          onError: (error) =>
            toast.error(
              error?.message ||
                messages["app.customerLeads.editCustomerLead.error"]
            ),
        }
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [triggerUpdateCustomerLead, id, messages, ref, formatMessage]
  );
  return (
    <AppFormModal
      ref={ref}
      data={formattedData}
      title={<IntlMessages id="app.customerLeads.editCustomerLead" />}
      onFinish={onHandleEditCustomerLead}
      isSubmitting={isMutatingUpdateCustomerLead}
      fieldsConfig={createOrEditCustomerLeadFieldConfig}
    />
  );
});

export default EditCustomerLeadModal;
